/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-27 21:12:09
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyCheckGroup from "../BsyCheckGroup";
import BsyTextTag from "../BsyTextTag";
import "./index.css";
import BsySubformBase from "../BsySubformBase";

class BsySubformCheckboxGroup extends BsySubformBase {
  static defaultProps = {
    baseCls: "bsy-subform-x-group",
  };

  constructor(props) {
    super(props);
    let obj = this.getDefaultValue();
    this.state = {
      ...props,
      ...obj,
    };
  }

  getValue = () => {
    const { value } = this.state;
    return value;
  };

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value, null, this],
        !1
      );
    }
  }

  clear = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.value = [];
    this.hasFocus = false;
    this.setState(
      {
        value: [],
      },
      () => {
        this.props.onStopEdit(this.state.value, null, this);
      }
    );
  };

  componentDidMount() {
    super.componentDidMount();
  }

  popUpPane = () => {
    const { items, value } = this.state;
    let that = this;
    return (
      <BsyCheckGroup
        colorEnable={this.props.colorEnable}
        items={items}
        value={value}
        minWidth={"auto"}
        onStopEdit={(e, item) => {
          that.isEditd = e !== that.state.value;
          that.value = e;
          that.setState({
            value: e,
          });
        }}
      ></BsyCheckGroup>
    );
  };

  popUpPaneClose = (e) => {
    this.hasFocus = false;
    let that = this;
    if (
      e &&
      e.target &&
      e.target.classList.contains("icon-dingding-guide-close")
    ) {
      this.value = null;
      that.setState(
        {
          value: that.value,
        },
        () => {
          BsyUtils.applyFunc(
            that,
            that.props.onStopEdit,
            [this.value, null, that],
            !1
          );
        }
      );
    } else {
      if (that.isEditd)
        BsyUtils.applyFunc(
          that,
          that.props.onStopEdit,
          [that.state.value, null, that],
          !1
        );
      else
        BsyUtils.applyFunc(
          that,
          that.props.onClose,
          [that.state.value, null, that],
          !1
        );
    }
    return !1;
  };

  renderItem = () => {
    const { items, value } = this.state;

    if (BsyUtils.isObjectEmpty(value)) {
      return "";
    }

    let newValue = value;
    if (!Array.isArray(newValue)) {
      newValue = [newValue];
    }

    if (!this.props.colorEnable) {
      return (
        <span className="select-val">{newValue ? newValue.join(",") : ""}</span>
      );
    } else {
      let valItems = [];
      items.map((a) => {
        if (value && value.indexOf(a.value) > -1) {
          valItems.push({ ...a });
        }
      });

      return (
        <>
          {valItems.map((item) => {
            return (
              <BsyTextTag
                customCls={" middle single-line"}
                text={item.text}
                color={item.color}
              >
                {" "}
              </BsyTextTag>
            );
          })}
        </>
      );
    }
  };

  renderDisablePane = () => {
    const { items, value } = this.state;
    let newValue = value;
    if (!Array.isArray(newValue)) {
      newValue = [newValue];
    }
    if (BsyUtils.isObjectEmpty(newValue)) {
      return (
        <div
          className={"bsy_form_item_disable "}
          data-watermark={React.language("content.empty")}
        ></div>
      );
    }

    if (!this.props.colorEnable) {
      var valstr = newValue ? newValue.join(",") : "";
      return (
        <div
          className={"bsy_form_item_disable "}
          data-watermark={React.language("content.empty")}
          title={valstr}
        >
          {valstr}
        </div>
      );
    }

    let valItems = [];
    items.map((a) => {
      if (value && value.indexOf(a.value) > -1) {
        valItems.push({ ...a });
      }
    });

    return (
      <div
        className={"bsy_form_item_disable "}
        data-watermark={React.language("content.empty")}
      >
        {valItems.map((item) => {
          return (
            <BsyTextTag
              customCls={" middle single-line"}
              text={item.text}
              color={item.color}
            >
              {" "}
            </BsyTextTag>
          );
        })}
      </div>
    );
  };

  render() {
    const { items, value } = this.state;
    const { cssName } = this.options;

    let css = {
      width: this.options.width,
      height: this.options.height,
    };
    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    return (
      <div
        className={cssName}
        style={css}
        ref={this.element}
        onClick={(e) => {
          this._onTriggerClick(e, "auto");
        }}
      >
        <div className="select-trigger">
          {this.renderItem()}
          {this.renderBtn("icon-widget-checkboxgroup", value)}
        </div>
      </div>
    );
  }
}

export default BsySubformCheckboxGroup;
